import { Card, CardContent, Typography } from "@mui/material";

interface KpiCardProps {
  label: string;
  value: string;
  tone?: "default" | "success" | "danger";
}

export default function KpiCard({ label, value, tone = "default" }: KpiCardProps) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        borderRadius: 2,
        borderColor: (theme) =>
          theme.palette.mode === "dark" ? theme.palette.divider : "rgba(84, 189, 193, 0.32)",
        backgroundColor: "background.paper",
      }}
    >
      <CardContent>
        <Typography variant="body2" color="text.secondary" fontWeight={700} gutterBottom>
          {label}
        </Typography>
        <Typography
          variant="h4"
          fontWeight={900}
          sx={{
            color: (theme) => {
              if (tone === "success") {
                return theme.palette.success.main;
              }
              if (tone === "danger") {
                return theme.palette.error.main;
              }
              return theme.palette.mode === "dark"
                ? theme.palette.primary.main
                : theme.palette.secondary.main;
            },
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}
